export enum ProductGroup {
  pharma = 'pharma'
}
